import { HiOutlineBookOpen, HiOutlineDocumentText, HiOutlineUpload } from "react-icons/hi";
import { Link, Route, BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { ThemePicker } from "./components/site/ThemePicker";
import Home from "./pages/Home";
import Read from "./pages/Read";
import ConvertEpub from "./pages/ConvertEpub";
import Upload from "./pages/Upload";
import Summary from "./pages/Summary";

const NAV_LINKS = [
  { to: "/", label: "Library", icon: HiOutlineBookOpen, end: true },
  { to: "/upload", label: "Upload", icon: HiOutlineUpload },
  { to: "/convert", label: "Convert", icon: HiOutlineDocumentText },
];

function NavBar() {
  const location = useLocation();

  const isActive = (to, end) => (end ? location.pathname === to : location.pathname.startsWith(to));

  return (
    <nav
      className="sticky top-0 z-50 border-b backdrop-blur-md"
      style={{ background: "var(--card)", borderColor: "var(--card-border)" }}
    >
      <div className="content-width mx-auto px-4 sm:px-6 py-3 flex justify-between items-center">
        <div className="flex items-center gap-1 sm:gap-2">
          {NAV_LINKS.map(({ to, label, icon: Icon, end }) => {
            const active = isActive(to, end);
            return (
              <Link
                key={to}
                to={to}
                className={`ink-wavy-active inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${active ? "is-active" : ""}`}
                style={{ color: active ? "var(--accent)" : "var(--foreground-muted)" }}
              >
                <Icon className="w-4 h-4" aria-hidden="true" />
                <span className="hidden sm:inline">{label}</span>
              </Link>
            );
          })}
        </div>
        <ThemePicker compact />
      </div>
    </nav>
  );
}

function AppContent() {
  const location = useLocation();
  const isReadPage = /^\/reading\/[^/]+\/read$/.test(location.pathname);

  return (
    <div className="flex flex-col h-screen overflow-hidden" style={{ background: "var(--background)", color: "var(--foreground)" }}>
      {!isReadPage && <NavBar />}
      <main className="flex-1 overflow-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/convert" element={<ConvertEpub />} />
          <Route path="/reading/:readingKey/read" element={<Read />} />
          <Route path="/reading/:readingKey/summary" element={<Summary />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
